import React, {useState} from "react";
import { NavLink } from "react-router-dom";

const Card = ({ cardImg1, cardImgIcon }) => {
  return (
    <div>
      <div className="bg-main-black rounded-[10px]">
        <div className="pt-[18px] px-[13px]  flex justify-center">
          <div className="relative w-full">
            <img className="w-full" src={cardImg1} alt="" />
            <div className="absolute  flex justify-center items-center  bottom-0 rounded-b-[10px] w-full h-[30px] bg-main-green">
              <h2 className="text-[#0E0E0E] text-[18px] leading-[21px] font-semibold">
                Drip Network
              </h2>
            </div>
            <div className="absolute bottom-[8px] left-[17px]">
              <img src={cardImgIcon} alt="" />
            </div>
          </div>
        </div>
        <div className="mt-[25px] pl-[33px] pr-[35px]">
          <ul>
            <li className="flex justify-between text-xs font-semibold mb-[10px]">
              <h6>Purchase Price</h6>
              <p className="text-bright-green">$2.30</p>
            </li>
            <li className="flex justify-between text-xs font-semibold mb-[10px]">
              <h6>All Time High Price</h6>
              <p className="text-bright-green">$197</p>
            </li>
            <li className="flex justify-between text-xs font-semibold mb-[10px]">
              <h6>Max Profit Point</h6>
              <p className="text-bright-green">85.6x</p>
            </li>
            <li className="flex justify-between text-xs font-semibold mb-[10px]">
              <h6>Allocation per Seat</h6>
              <p className="text-bright-green">1,000 Drip</p>
            </li>
            <li className="flex justify-between text-xs font-semibold mb-[29px]">
              <h6>Raised Amount</h6>
              <p className="text-bright-green">$2,500,000</p>
            </li>
          </ul>
        </div>
        <>
          <button className="bg-main-green w-full rounded-b-[10px] h-[30px] py-[5px]">
            <h5 className="text-center text-res-xs text-light-black font-bold">
              View Details
            </h5>
          </button>
        </>
      </div>
    </div>
  );
};

export default Card;
